import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import { IPageV2 } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/IPageV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { Notification } from "@/models/notification/Notification";
import { UpdateNotificationRequest } from "@/models/notification/UpdateNotificationRequest";

class LazoNotificationService {
  path: string;
  constructor(path: string) {
    this.path = path;
  }

  getAllPagedNotifications(page: number, pageSize: number = 10, tenantExternalId?: string): Promise<ApiResponseV2<IPageV2<Notification>>> {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
    });
    if (tenantExternalId) {
      params.append("tenantExternalId", tenantExternalId);
    }

    return HttpClientV2.get(`${this.path}/all`, { axiosConfig: { params } });
  }

  getCountNotifications(tenantExternalId?: string): Promise<ApiResponseV2<number>> {
    const query = tenantExternalId ? `?tenantExternalId=${encodeURIComponent(tenantExternalId)}` : "";
    return HttpClientV2.get(`${this.path}/count-unread${query}`);
  }

  updateNotifications(request: UpdateNotificationRequest): Promise<ApiResponseV2<Notification[]>> {
    return HttpClientV2.put(`${this.path}/update-status`, request);
  }

  async markAllNotificationsAsRead(userExternalId: string): Promise<ApiResponseV2<string>> {
    return HttpClientV2.patchWithoutPayload(`${this.path}/mark-all-as-read?userExternalId=${userExternalId}`);
  }

  notifyDocumentDeliveryToCompanyUsers(
    creatorUserExternalId: string,
    documentExternalId: string,
    productFlowExternalId?: string,
    tenantExternalId?: string
  ): Promise<ApiResponseV2<Notification>> {
    return HttpClientV2.post(`${this.path}/notify-document-delivery`, {
      productFlowExternalId,
      documentExternalId,
      creatorUserExternalId,
      tenantExternalId,
    });
  }
}

export default new LazoNotificationService("/api/notification");
